import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RidReadingBasisInstructionMode } from '../../../../mechanics/rid-reading-basis-instruction-mode/rid-reading-basis-instruction-mode';

@Component({
  selector: 'app-reading-basis-instruction-mode-per-soundfoot-page',
  imports: [RidReadingBasisInstructionMode],
  templateUrl: './reading-basis-instruction-mode-per-soundfoot-page.html',
})
export class ReadingBasisInstructionModePerSoundfootPage {
  protected readonly $activatedRoute = inject(ActivatedRoute);
  protected readonly $router = inject(Router);

  protected readonly pace = () => parseInt(this.$activatedRoute.snapshot.queryParams['pace'] ?? '500');
}
